import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import { evaluatePassword } from '../../../utils/passwordRules'
import './styles.css'

// One segment per strength level (1 = Weak … 3 = Strong); the first `level`
// segments light up in the level's color.
const METER_SEGMENTS = [1, 2, 3]

// Live password feedback shown under a password field: a strength meter (once
// the user types) plus the rule/tips list, listed upfront so users know the
// requirements before submitting. Rules are matched to the backend validators
// in src/utils/passwordRules.js.
export function PasswordStrength({ password = '', similarityTip = false }) {
  const { strength, rules } = evaluatePassword(password)
  const hasInput = password.length > 0

  const tips = similarityTip
    ? [...rules, { key: 'similarity', label: 'Don’t use your name or email', met: null }]
    : rules

  return (
    <div className="password-strength" aria-live="polite">
      {hasInput && (
        <div className={`password-strength__meter -level-${strength.level}`}>
          <div className="password-strength__track">
            {METER_SEGMENTS.map((segment) => (
              <span
                key={segment}
                className={classnames('password-strength__segment', {
                  '-filled': segment <= strength.level
                })}
              />
            ))}
          </div>
          <span className="password-strength__quality">
            Password quality: {strength.label}
          </span>
        </div>
      )}
      <ul className="password-strength__rules">
        {tips.map((rule) => (
          <li
            key={rule.key}
            className={classnames('password-strength__rule', {
              '-met': rule.met === true,
              '-advisory': rule.met === null
            })}
          >
            {rule.label}
          </li>
        ))}
      </ul>
    </div>
  )
}

PasswordStrength.propTypes = {
  password: PropTypes.string,
  similarityTip: PropTypes.bool
}

export default PasswordStrength
